var service = function($rootScope, $http) {
  var addProductLineTag = function(tag, productLine, cb) {
    $http({
      method: 'POST',
      url: '/api/admin/product_line_tags/',
      data: {
        product_line_tag: {
          tag_id: tag.id,
          product_line_id: productLine.id
        }
      }
    }).then(function success(res) {
      if (cb) { cb(res.data); }
    }, function error(res) {
      console.log(res.data);
    });
  };

  var addRetailerTag = function(tag, retailer, cb) {
    $http({
      method: 'POST',
      url: '/api/admin/retailer_tags/',
      data: {
        retailer_tag: {
          tag_id: tag.id,
          retailer_id: retailer.id
        }
      }
    }).then(function success(res) {
      if (cb) { cb(res.data); }
    }, function error(res) {
      console.log(res.data);
      alert("There was an error while updating the retailer tags. Please try again later.");
    });
  };

  var addTag = function(tag, tag_type, cb) {
    $http({
      method: 'POST',
      url: '/api/admin/tags/',
      data: {
        tag: {
          name: tag.name,
          hidden: tag.hidden,
          tag_type: tag_type
        }
      }
    }).then(function success(res) {
      cb(res.data);
    }, function error(res) {
      console.log(res.data);
      alert("There was an error adding this tag. Please try again later.");
    });
  };

  var add = function(tag, tag_type, obj, cb) {
    if (tag.id) {
      if (tag_type == 'product_line') {
        return addProductLineTag(tag, obj, cb);
      } else if (tag_type == 'retailer') {
        return addRetailerTag(tag, obj, cb);
      }
    } else {
      return addTag(tag, tag_type, function(newTag) {
        if (!obj) {
          return cb(newTag);
        }
        if (tag_type == 'product_line') {
          return addProductLineTag(newTag, obj, cb);
        } else if (tag_type == 'retailer') {
          return addRetailerTag(newTag, obj, cb);
        }
      });
    }
  };

  var removeProductLineTag = function(tag) {
    $http({
      method: 'DELETE',
      url: '/api/admin/product_line_tags/' + tag.product_line_tag_id
    }).then(function success(res) {
    }, function error(res) {
      console.log(res.data);
      alert("There was an error while updating the product line tags. Please try again later.");
    });
  };
  var removeRetailerTag = function(tag) {
    $http({
      method: 'DELETE',
      url: '/api/admin/retailer_tags/' + tag.retailer_tag_id
    }).then(function success(res) {
    }, function error(res) {
      console.log(res.data);
    });
  };

  var getByID = function(ids, cb, errcb) {
    _.each(ids, function(id) {
      if (_.isInteger(parseInt(id))) {
        $http({
          method: 'GET',
          url: '/api/admin/tags/' + id
        }).then(function success(res) {
          cb(res.data);
        });
      }
    });
  };

  return {
    add: add,
    removeProductLineTag: removeProductLineTag,
    removeRetailerTag: removeRetailerTag,
    getByID: getByID
  };

};

service.$inject = ['$rootScope', '$http'];

tiz.service('Tag', service);
